import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "site-header site-header--active-white" }
const _hoisted_2 = { class: "site-header__wrapper" }
const _hoisted_3 = { class: "site-header__navigation" }
const _hoisted_4 = {
  href: "/",
  class: "site-header__logotype"
}
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "site-header__links" }
const _hoisted_7 = ["href"]

import {computed, onMounted, ref} from "vue";
import {useApi} from "@shared/Services/axios-service";
import {getTranslations} from "@shared/Services/translations";
import AccountMenu from "@shared/Layout/SiteHeader/AccountMenu/AccountMenu.vue";
import LanguagePicker from "@shared/Layout/SiteHeader/LanguagePicker/LanguagePicker.vue";
import LoginLink from "@shared/Layout/SiteHeader/LoginLink/LoginLink.vue";
import {useAuth} from "@services/authentication";
import { getBookingRouteUrl } from "@services/booking-route-service";
import { RouteNames } from "@services/booking-route-service";


export default /*@__PURE__*/_defineComponent({
  __name: 'SiteHeader',
  setup(__props) {

const translations = getTranslations();
const {data: logotypeData, get: getHeaderLogotype} = useApi<HeaderLogotype>("/layout/logotype");
const logotype = ref<HeaderLogotype | null>(null);
const auth = useAuth();
const isAuthenticated = computed(() => auth.isAuthenticated());
const isBusinessCustomer = computed(() => auth.isBusinessCustomer());
const isSluiceHost = computed(() => auth.isSluiceHost());

const menuItems: MenuItem[] = [
  { linkText: translations["bookings.accountmenu.mybookings"], routeName: RouteNames.MyBookings },
  { linkText: translations["bookings.accountmenu.mysettings"] ?? "My settings", routeName: RouteNames.MySettings },
  { linkText: translations["bookings.accountmenu.myboatdetails"] ?? "My boat details", routeName: RouteNames.ManageBoats },
  { linkText: translations['bookings.accountmenu.bookingsstart'], routeName: RouteNames.SelectTicket },
];

const sluiceHostMenuItems: MenuItem[] = [
  { linkText: translations['bookings.accountmenu.sluicehost.bookings'], routeName: RouteNames.SluiceHost },
  { linkText: translations['bookings.accountmenu.sluicehost.bookingsstart'], routeName: RouteNames.SelectTicket }
];

onMounted(() => {
  getHeaderLogotype().then(() => {
    logotype.value = logotypeData.value ?? null;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("a", _hoisted_4, [
          (logotype.value?.logotypeUrl)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: logotype.value.logotypeUrl,
                alt: _unref(translations)['bookings.header.logotype.alt']
              }, null, 8 /* PROPS */, _hoisted_5))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (!isAuthenticated.value || isAuthenticated.value && !isBusinessCustomer.value)
            ? (_openBlock(), _createBlock(LanguagePicker, {
                key: 0,
                class: "site-header__link site-header__link--language-picker"
              }))
            : _createCommentVNode("v-if", true),
          (isAuthenticated.value && isSluiceHost.value)
            ? (_openBlock(), _createBlock(AccountMenu, {
                key: 1,
                "menu-items": sluiceHostMenuItems,
                class: "site-header__link"
              }))
            : (isAuthenticated.value && !isSluiceHost.value)
              ? (_openBlock(), _createBlock(AccountMenu, {
                  key: 2,
                  "menu-items": menuItems,
                  class: "site-header__link"
                }))
              : _createCommentVNode("v-if", true),
          (!isAuthenticated.value)
            ? (_openBlock(), _createBlock(LoginLink, {
                key: 3,
                class: "site-header__link"
              }))
            : _createCommentVNode("v-if", true),
          _createElementVNode("a", {
            href: _unref(getBookingRouteUrl)(_unref(RouteNames).ContactInformation),
            class: "site-header__link site-header__contact-link"
          }, [
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "site-header__contact-icon icon icon--phone" }, null, -1 /* CACHED */)),
            _createTextVNode(" " + _toDisplayString(_unref(translations)['bookings.header.contact']), 1 /* TEXT */)
          ], 8 /* PROPS */, _hoisted_7)
        ])
      ])
    ])
  ]))
}
}

})